import { createAsyncThunk, createSlice, EntityState } from '@reduxjs/toolkit';
import { SavedSearchCriteriaCommonModel } from 'types/entity';
import { notificationActions } from 'redux/notification/notification.slice';
import { deleteSearchCriteria, putSearchCriteria } from 'api/search-criteria.service';
import { searchCriteriaUpdateAdaptor } from './search-criteria-update.adapter';

export const SEARCH_CRITERIA_UPDATE_STORE_NAME = 'searchCriteriaUpdate';

export const updateSearchCriteriaThunk = createAsyncThunk(
  `${SEARCH_CRITERIA_UPDATE_STORE_NAME}/upsert`,
  async (args: [projectId: string, criteria: SavedSearchCriteriaCommonModel], thunkAPI) => putSearchCriteria(args[0], args[1]).then((data) => {
    thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'FpFileSearch.notification.save-criteria.success' }));
    return data;
  }),
);

export const deleteSearchCriteriaThunk = createAsyncThunk(
  `${SEARCH_CRITERIA_UPDATE_STORE_NAME}/delete`,
  async (args: [projectId: string, criteria: SavedSearchCriteriaCommonModel]) => deleteSearchCriteria(args[0], args[1]),
);

export type SearchCriteriaUpdateState = EntityState<SavedSearchCriteriaCommonModel> & {
  updated: boolean
  error?: any
}

export const initialSearchCriteriaUpdateState: SearchCriteriaUpdateState = searchCriteriaUpdateAdaptor.getInitialState({
  updated: false,
  error: null,
});

export const searchCriteriaUpdateSlice = createSlice({
  name: SEARCH_CRITERIA_UPDATE_STORE_NAME,
  initialState: initialSearchCriteriaUpdateState,
  reducers: {
    unUpdated: (state) => {
      state.updated = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateSearchCriteriaThunk.pending, (state) => {
      state.updated = false;
    });
    builder.addCase(updateSearchCriteriaThunk.fulfilled, (state) => {
      state.updated = true;
    });
    builder.addCase(updateSearchCriteriaThunk.rejected, (state, action) => {
      state.updated = true;
      state.error = action.payload;
    });

    // 削除
    builder.addCase(deleteSearchCriteriaThunk.pending, (state) => {
      state.updated = false;
    });
    builder.addCase(deleteSearchCriteriaThunk.fulfilled, (state) => {
      state.updated = true;
    });
    builder.addCase(deleteSearchCriteriaThunk.rejected, (state, action) => {
      state.updated = true;
      state.error = action.payload;
    });
  },
});

export const searchCriteriaUpdateActions = {
  ...searchCriteriaUpdateSlice.actions,
  upsert: updateSearchCriteriaThunk,
  delete: deleteSearchCriteriaThunk,
};

export default searchCriteriaUpdateSlice.reducer;
